import { combineReducers } from 'redux'
import { merge } from 'lodash'

import { actionTypeCreator } from './util'
import { serviceTypes } from '@src/globals'

// /////////////////////////////////////////////////////////////////////////////
// Constants
// /////////////////////////////////////////////////////////////////////////////
export const constants = {
  NAME: 'bookingSetup'
}

// /////////////////////////////////////////////////////////////////////////////
// Action Types
// /////////////////////////////////////////////////////////////////////////////
const createActionType = actionTypeCreator.bind(undefined, constants.NAME)
export const UPDATE = createActionType('UPDATE')
export const RESET = createActionType('RESET')
export const NEXT_STEP = createActionType('NEXT_STEP')
export const PREVIOUS_STEP = createActionType('PREVIOUS_STEP')
export const FINISH = createActionType('FINISH')

// /////////////////////////////////////////////////////////////////////////////
// Actions
// /////////////////////////////////////////////////////////////////////////////
export function update (payload) {
  return {
    type: UPDATE,
    payload
  }
}

export function reset () {
  return {
    type: RESET
  }
}

export function nextStep () {
  return {
    type: NEXT_STEP
  }
}

export function previousStep () {
  return {
    type: PREVIOUS_STEP
  }
}

export function finish () {
  return {
    type: FINISH
  }
}

// /////////////////////////////////////////////////////////////////////////////
// Selectors
// /////////////////////////////////////////////////////////////////////////////
export const getCurrentStep = (state) => state[constants.NAME].currentStep
export const getSetup = (state) => state[constants.NAME].setup

// /////////////////////////////////////////////////////////////////////////////
// Queries
// /////////////////////////////////////////////////////////////////////////////
export const isEdited = (state) => state[constants.NAME].edited

// /////////////////////////////////////////////////////////////////////////////
// Reducer
// /////////////////////////////////////////////////////////////////////////////
const currentStepInitialState = 0

export function currentStep (state = currentStepInitialState, action = {}) {
  switch (action.type) {
    case NEXT_STEP:
      return state + 1
    case PREVIOUS_STEP:
      return Math.max(currentStepInitialState, state - 1)
    case RESET:
      return currentStepInitialState
    default:
      return state
  }
}

const setupInitialState = {
  location: {
    label: '',
    placeId: ''
  },
  date: '1970-01-01', // should merge these two fields into datetime with timezone in utc
  time: 9,
  estimatedHours: -1,
  rooms: 1,
  bathrooms: 1,
  desks: 8,
  skills: {
    cleaning: true,
    laundry: false,
    ironing: false,
    cooking: false
  },
  preferences: {
    children: false,
    pets: false,
    offices: false
  },
  serviceTypeId: serviceTypes.WEEKLY.id,
  weekdays: []
}

export function setup (state = setupInitialState, action = {}) {
  switch (action.type) {
    case UPDATE:
      return merge({}, state, action.payload)
    default:
      return state
  }
}

function edited (state = false, action = {}) {
  switch (action.type) {
    case UPDATE:
      return true

    case RESET:
    case FINISH:
      return false

    default:
      return state
  }
}

export const reducer = combineReducers({
  currentStep,
  setup,
  edited
})



// WEBPACK FOOTER //
// ./src/redux/modules/bookingSetup.js